import "./App.css";
import AllRoutes from "./components/AllRoutes/AllRoutes";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { Divider, Stack } from "@mui/material";
import Sidebar from "./components/Sidebar/Sidebar";
import { rootColors } from "./utilities/Colors/Colors";
import { ThemeProvider } from "@emotion/react";
import customTheme from "./utilities/customTheme/customTheme";

function App() {
  return (
    <Stack sx={{ bgcolor: rootColors?.bgColor, color: rootColors?.text }}>
      <Navbar />
      <Stack direction={"row"} gap={2}>
        <Stack>
          <Sidebar />
        </Stack>
        <Stack
          sx={{
            flex: 1,
            marginLeft: { xs: 0, md: "300px" },
            overflowY: "auto",
          }}
        >
          <ThemeProvider theme={customTheme}>
            <AllRoutes />
            <Divider />
            <Footer />
          </ThemeProvider>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default App;
